import react from "react";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import { Bar } from "react-chartjs-2";

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);

export const options = {
  responsive: true,
  maintainAspectRatio: false,
};

const BarChart = (props) => {
  const datasets = [];
  props.members.map((member) => {
    datasets.push({
      label: member.userName,
      data: [member.amountOfPoints],
      backgroundColor: member.color,
    });
  });
  const labels = ["This Month"];

  const data = {
    labels,
    datasets,
  };

  return (
    <div id="bar-container">
      <Bar data={data} options={options} />
    </div>
  );
};

export default BarChart;
